import getMediaUrl from "utils/getMediaUrl"

const getReactPlayerPlaceholder = (assets) => {
  const getAssetsModel = (assets && assets.medium) || assets
  return getMediaUrl(getAssetsModel)
}

export default getReactPlayerPlaceholder
